import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import '../styles/spinner.scss';

/** Shows a spinner */
const Spinner = ({expand}) => {
  return <div className={classNames('Spinner', {Expand: expand})} />;
};

Spinner.propTypes = {
  /** Expands the spinner by adding space above and below */
  expand: PropTypes.bool,
};

export default Spinner;
